import { useSelector } from 'react-redux';
import { selectFeatureFlags } from '@/model/selectors';

export function useIsEdjPilotAdvisor() {
  const featureFlags = useSelector(selectFeatureFlags);
  return !!featureFlags.edjPilotAdvisor;
}

export function useIsEdjPilotAdvisorIntakeForm() {
  const featureFlags = useSelector(selectFeatureFlags);
  return !!featureFlags.edjPilotAdvisor && !!featureFlags.edjAdvisorPilotIntakeForm;
}
